<template>
  <div class="">
      <div class="columns is-gapless has-bg-reserve is-padding has-text-white" v-if="isAdmin || isSectorManager">
      <div class="column is-5 is-padding-top-large is-padding-bottom-large">
        <span class="is-uppercase">Taux commercialisation programme</span>
      </div>
      <div class="column is-4 columns is-gapless is-column is-margin-left">
        <!-- <div class="column is-padding-top-small">
          <div class="field has-addons">
            <div class="control">
              <input ref="inputTxCommer" id="inputTxCommer" class="input is-transparent" type="number"
                     min="0" max="100"
                     step=".1" placeholder="0"
                     size="5"
                     v-model.number="adv.remuneration"
                     @focus="selectInput('inputTxCommer')"
                     @change="updateRemuneration(adv.remuneration)">
            </div>
            <div class="control">
              <a class="button is-static is-border is-min-width-0">
                <span class="icon"><i class="fas fa-percentage"></i></span>
              </a>
            </div>
          </div>
        </div> -->
        <div class="">
          <!-- Ancien input -->
          <!--<div class="field has-addons is-marginless-bottom">
            <div class="control"><a class="button is-square is-static is-border is-min-width-0"><span class="icon"><i class="fas fa-percent"></i></span></a></div>
            <div class="control is-expanded">
              <input name="taux_com" v-model.number="adv.remuneration"
                      @input="tauxComInput" max="100"
                      class="input" step=".1" type="number"
                      data-type-cy="input" data-value-cy="input_contact_taux_com">
            </div>
          </div>-->
          <label for="taux_com" class="label has-text-white">Taux de commercialisation</label>
          <div class="field has-addons">
            <v-input id="taux_com"
              :name="'taux_com'"
              @input="val => tauxComInput(val)"
              :model="adv.remuneration"
              :errors-bag="errors"
              data-vv-value-path="val"
              classes="has-text-centered w90p"
              :max="100" :number="true"
              input-type="number"
              data-vv-as=" "
              icon="fa-percentage"
              v-validate="'required|decimal:2'"
              :hasIncrementations="true"
              :incrementationsPas="0.1">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </div>
              <div class="control"
                v-if="displayNewTauxComButton"
              >
                <a @click="newTauxCom" 
                  class="button is-success is-square tooltip is-tooltip-right"
                  data-tooltip="Valider la modification du taux">
                  <span class="icon"><i class="fas fa-save"></i></span>
                </a>
              </div>
              <div class="control" v-if="displayNewTauxComButton">
                <a @click="editTauxCom" data-tooltip="Annuler la modification du taux" 
                  class="button tooltip is-tooltip-right is-square is-draft">
                  <span class="icon has-text-white"><i class="fas fa-times"></i></span>
                </a>
              </div>
            </v-input>
          </div>
        </div>
        <!-- <div class="is-padding-top-large" v-else-if="!showEditRem">
          <span class="is-size-4">{{adv.remuneration}} %</span>
          <span class="icon" @click="editTauxCom"><i class="fas fa-pen-square"></i></span>
        </div> -->

      </div>
      <div class="column is-padding-top-large is-padding-bottom-large has-text-right"> <!-- v-if="!tauxComInputEnabled" -->
        <span class="has-text-weight-bold">{{Number(adv.marge_promoteur_ht).toFixed(2)}} {{$currency}} HT</span>
      </div>
    </div>

    <div class="is-border-left is-border-right">
      <seller-share v-for="(share, i) in shares"
                    :key="share.seller"
                    :share="share"
                    :i="i"
                    @updateSellerRemuneration="updateSellerRemuneration"
                    @updateSellerShare="updateSellerShare"
                    @sellerFacturation="sellerFacturation"
                    @removeSellerShare="removeSellerShare"
      ></seller-share>
    </div>
    
    <div v-if="shares.length < 3 && (isAdmin || isSectorManager) && !adv.terminated" class="row-width-actions-bar">
      <button @click="openSellerSelection"
        class="page-header-btn button is-grey-dark is-fullwidth is-radiusless">
        <span>Ajouter un vendeur</span>
      </button>
    </div>

    <div class="columns is-gapless is-padding has-bg-reserve-darken-1 has-text-white is-margin-top-xsmall" v-if="isAdmin || isSectorManager">
      <div class="column is-uppercase">Restant sur vente</div>
      <div class="column is-uppercase has-text-right">
        <div class="has-text-weight-bold">{{Number(adv.total_less_bonuses_ht).toFixed(2)}} {{$currency}} HT</div>
        <div>{{Number(adv.total_less_bonuses_ttc).toFixed(2)}} {{$currency}} TTC</div>
      </div>
    </div>

    <div v-if="isAdmin || isSectorManager" class="has-bg-white is-border is-margin-top-xxsmall">
      <div class="row-width-actions-bar columns is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
          <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
            class="icon is-size-4">
            <i v-if="!openComment" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-up"></i>
            </span></button>
        </div>
      </div>
      <template v-if="openComment">
        <div v-if="!openWysi" class="vadDiscussion is-border-top">
          <div
            class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div class="content" v-if="adv.remuneration_step.comment" v-html="adv.remuneration_step.comment"></div>
            <div class="content" v-else>Aucun commentaire</div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button @click="openWysiwyg" class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light='true' :tooltip-top="true"
              :model="commentaire"
              @change="val => commentaire = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button @click="saveAdv()" type="button" class="button is-success">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </button>
            </div>
            <div class="">
              <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
  import { debounce, clone } from 'lodash'
  import { AdvMx, Error } from '@/mixins'
  import SellerShare from './SellerShare'
  import { mapState } from 'vuex'

  export default {
    name: 'Commercialisation',
    mixins: [AdvMx, Error],
    components: {SellerShare},
    data () {
      return {
        openComment: true,
        openWysi: false,
        commentaire: null,
        tauxComInputEnabled: false,
        displayNewTauxComButton: false,
        save: false,
        service: this.$api.advService,
        editShare: false,
        error: {},
        displayInlineError: true,
        showEditRem: false,
        savedTauxCom: null
      }
    },
    computed: {
      ...mapState(['quickview']),
      shares () {
        return this.sourceShares
      },
      sellersPk () {
        return this.shares.map(x => x.seller)
      },
      comTTC () {
        return Math.floor(this.adv.sale_price_with_discount * this.adv.remuneration / 100)
      },
      comHT () {
        return Math.floor(this.adv.sale_price_ht_with_discount * this.adv.remuneration / 100)
      },
      margeCompany () {
        return (this.adv.remuneration - this.adv.seller_share).toFixed(2)
      }
      // canEditTauxCom () {
      //   return !this.sourceShares.slice().reduce((a, b) => {
      //     if (b.deposits.length) {
      //       b.deposits.forEach((x) => {
      //         if (x.terminated) a++
      //       })
      //     }
      //     if (b.terminated) a++
      //     return a
      //   }, 0)
      // }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            results.entities.forEach(x => {
              this.addSeller(x)
            })
          }
        }
      }
    },
    methods: {
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.remuneration_step.comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.remuneration_step, 'comment', this.commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      newTauxCom () {
        if (this.adv.remuneration < this.adv.sellers_shares) {
          if (this.adv.sellers_shares === this.adv.seller_share) {
            this.$notify({
              type: 'is-danger',
              text: 'Rémunération du vendeur supérieure au taux de commercialisation'
            })
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Rémunération des vendeurs supérieure au taux de commercialisation'
            })
          }
        } else if (this.adv.terminated) {
          this.$notify({
            type: 'is-danger',
            text: 'Modification du taux impossible car facture finalisée'
          })
        } else {
          this.tauxComInputEnabled = !this.tauxComInputEnabled
          this.displayNewTauxComButton = !this.displayNewTauxComButton
          this.saveAdv(this.adv)
        }
      },
      tauxComInput (val) {
        this.savedTauxCom = clone(this.adv.remuneration)
        this.$nextTick(() => {
          this.adv.remuneration = val
          this.displayNewTauxComButton = true
        })
      },
      editTauxCom () {
        this.tauxComInputEnabled = !this.tauxComInputEnabled
        this.adv.remuneration = clone(this.savedTauxCom)
        this.displayNewTauxComButton = false
      },
      saveNewRem () {
        this.commitAdv()
        this.showEditRem = false
      },
      updateSellerRemuneration: debounce(function (e, share, idx) {
        // this.editAdv(true)
        // this.editShare = true
        // let value = e.target ? e.target.value : e
        // if (value && !isNaN(value) && value >= 0) {
        //   if (value > 100) {
        //     value = 1
        //   }
        //   share.remuneration = Number(value)
        // } else {
        //   share.remuneration = 0
        // }
      }, 500),
      updateSellerShare (share = null) {
        let _this = this
        this.save = true
        if (share) {
          this.service.putShare(this.adv.pk, share.seller, share).then(res => {
            this.saveAdv(this.adv)
            this.save = false
            this.editShare = false
            this.updateCom()
          }).catch(err => {
            if (err.response.data.extra === 'ADV_REMUNERATION_ERROR') {
              this.$notify({
                type: 'is-danger',
                text: 'Rémunération du vendeur supérieure au taux de commercialisation'
              })
            }
            this.save = false
            this.editShare = false
            this.updateCom()
            this.handleError(err)
          })
        } else {
          saveAll().then(() => {
            this.saveAdv(this.adv)
            this.save = false
            this.editShare = false
            this.editAdv(false)
            this.updateCom()
          }).catch(err => {
            this.save = false
            this.editShare = false
            this.editAdv(false)
            this.handleError(err)
          })
        }
        function saveAll () {
          return new Promise((resolve, reject) => {
            _this.shares.forEach((share, i) => {
              _this.service.putShare(_this.adv.pk, share.seller, share).then(res => {
                if (i === _this.shares.length - 1) return resolve()
              }).catch(err => {
                return reject(err)
              })
            })
          })
        }
      },
      removeSellerShare (share) {
        this.save = true
        this.service.deleteShare(this.adv.pk, share.seller).then(res => {
          this.save = false
          this.updateCom()
        }).catch(err => {
          this.handleError(err)
        })
      },
      updateRemuneration: debounce(function (val) {
        this.adv.remuneration = Number(val)
        // this.saveAdv(this.adv)
      }, 500),
      openSellerSelection () {
        let params = {
          excludes: this.sellersPk
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params: params})
      },
      addSeller (seller) {
        let share = {
          seller: seller.pk,
          remuneration: 0
        }
        this.save = true
        this.service.postShare(this.adv.pk, share).then(res => {
          this.save = false
          this.shares.push(res.data)
          let sharesPk = this.shares.map(x => x.pk)
          this.adv.co_sellers = sharesPk
          // this.saveAdv(this.adv)
        }).catch(err => {
          this.save = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du vendeur'
          })
          console.log(err)
        })
      },
      sellerFacturation (share) {
        this.$emit('changePanel', {panel: 'FACTURATION', share})
      }
    },
    created () {
      if (this.adv.remuneration_step.comment) this.commentaire = this.adv.remuneration_step.comment
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Commercialisation/Commercialisation.vue